export default __webpack_public_path__ + "static/media/sunshine.b84eb98f.png";